import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_we9tdmh5ka: FaireBrandEntity = {
  token: "b_we9tdmh5ka",
  type: "brand",
  name: "The Sacred Wild Candle Co",
  avatarUrl:
    "https://cdn.faire.com/fastly/ddc77d3077ed473c80bd6645d604114556ab5675318c52ac2e9508378b4b08ee.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/fae01a254a2086f1b78102ea33de72cc758e37a23ff737ef11a1f2a0eaffa4fb.png",
  logoUrl:
    "https://cdn.faire.com/fastly/ddc77d3077ed473c80bd6645d604114556ab5675318c52ac2e9508378b4b08ee.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fae01a254a2086f1b78102ea33de72cc758e37a23ff737ef11a1f2a0eaffa4fb.png",
  location: "Eureka, MT, USA",
  minimumOrderDollars: 208,
  rating: 5,
  reviewCount: 83,
  isTopShop: true,
  isInsider: true,
  description:
    "Exceptional, Clean, Spa-Like Fragrances to uplift and Inspire.\nEverything extraordinary starts with good intentions and a little magick!   \nThat's why we only use exceptional, best quality natural ingredients in our candles and room sprays.   Our plant-based, non-toxic candles are hand-poured in small batches, made with Phthalate Free, Premium Grade Fragrances and Essential Oils, and ingredients because indoor air quality is important in your sacred space.  \nWe use 100% virgin coco-soy wax, wood wicks, recycled vessels and sustainably sourced fragrance oils because it's the right thing to do for our planet, and for our homes. \nOur Palo Santo Matchsticks are sourced from the waste left behind from the manufacturing of larger size smudge sticks. \nOur NEW body & room mysts are elegant, plant-based and uplifting. WAY better than poo-pourri!  \n*Ask for a link to our lifestyle photos you are welcome to use for social media and marketing!\n**When you order the Intention Collection, we provide a beautiful 8 x 10 POS / Shelf sign to motivate customers - and carrying the whole line has proved to provide even faster sell-through. \nWe are a mother-daughter company based on a regenerative ranch in the beautiful mountains of NW Montana.  \nSet your intentions ablaze!",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:52.057Z",
    importedBy: "entity-db-cli",
  },
};
